import React from "react";
import "./About.css";
import abhijith from "./abhijith.jpg";
import { AiFillHtml5 } from "react-icons/ai";
import { FaCss3Alt } from "react-icons/fa";
import { TbBrandJavascript } from "react-icons/tb";
import { FaReact } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { SiAltiumdesigner } from "react-icons/si";
import { IoMdNavigate } from "react-icons/io";
import { AiOutlineCodeSandbox } from "react-icons/ai";
import { FaExchangeAlt } from "react-icons/fa";
import { SiMaterialdesignicons } from "react-icons/si";

const About = (props) => {
  return (
    <section className={"aboutme " + props.className} id="about">
      <p className="about-me">About Me</p>

      <div className="about-content">
        <div className="para">
          <div className="newgrid">
            <div className="desc_box">
              <p>
                Hello, my name is Abhijith and I am passionate about creating
                websites and working in the field of computer science. My
                interest in web development grew during my final year when I had
                to make a project for my last sem. The project I chose to build
                was an online food ordering website using HTML, CSS, Javascript,
                PHP and MYSQL. I enjoyed making that project. Every step was a
                new learning process for me.
              </p>
              <br />
              <p>
                Apart from that I enjoy playing cricket, watching Anime and
                sketching.
              </p>
            </div>
            <div className="tech_skills">
              <p className="about-header">My Technical Skills</p>
              <ul className="about-skills">
                <li className="skill">
                  HTML
                  <span>
                    <AiFillHtml5 />
                  </span>
                </li>
                <li className="skill">
                  CSS
                  <span>
                    <FaCss3Alt />
                  </span>
                </li>
                <li className="skill">
                  JavaScript
                  <span>
                    <TbBrandJavascript />
                  </span>
                </li>
                <li className="skill">
                  ReactJS
                  <span>
                    <FaReact />
                  </span>
                </li>
                <li className="skill">
                  React Hooks
                  <span>
                    <FaExchangeAlt />
                  </span>
                </li>
                <li className="skill last">
                  React Router
                  <span>
                    <IoMdNavigate />
                  </span>
                </li>
                <li className="skill last">
                  Python
                  <span>
                    <FaPython />
                  </span>
                </li>
                <li className="skill last">
                  Website Design
                  <span>
                    <SiMaterialdesignicons />
                  </span>
                </li>
                <li className="skill last">
                  Responsive Design
                  <span>
                    <AiOutlineCodeSandbox />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* <div className="image"> */}
        {/* <img src={abhijith} alt="profile" /> */}
        {/* </div> */}
      </div>
    </section>
  );
};

export default About;
